import { type ScopeChangeRequestStatus } from './ScopeChangeRequest'
import { match } from '@/utils/pattern-match-util'

/**
 * Query string builder for the Scope Change Request Search API.
 */
export class ScopeChangeRequestQueryStringBuilder {
  private _statuses = ''

  /**
   * Searches for scope change requests with any status.
   *
   * @param statuses
   */
  withStatuses(
    statuses?: ScopeChangeRequestStatus[],
  ): ScopeChangeRequestQueryStringBuilder {
    if (!statuses) {
      return this
    }

    this._statuses += statuses
      .map((s) => condition('status', '=', toScopeChangeRequestStatus(s)))
      .join(' OR ')
    return this
  }

  /**
   * Builds the query string.
   *
   */
  build(): string {
    return this._statuses
  }
}

/**
 * Generates a condition and escapes the passed value.
 *
 * @param field
 * @param operator
 * @param value
 */
function condition(
  field: string,
  operator: ConditionOperator,
  value: string,
): string {
  // eslint-disable-next-line no-useless-escape
  return `${field}${operator}\"${value}\"`
}

type ConditionOperator = '=' | '>' | '<' | '>=' | '<=' | ':'

function toScopeChangeRequestStatus(status: ScopeChangeRequestStatus) {
  return match<ScopeChangeRequestStatus, string>(status, {
    PendingFinalization: () => 'PendingFinalization',
    PendingAdminApproval: () => 'PendingAdminApproval',
    PendingClientApproval: () => 'PendingClientApproval',
    Accepted: () => 'Accepted',
    Rejected: () => 'Rejected',
    ApplyFailed: () => 'ApplyFailed',
    Unspecified: () => '',
  })
}
